import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20soft%20pastel%20mint%20green%20and%20cream%20tones%20featuring%20floating%20product%20shapes%20and%20gentle%20gradients%20clean%20modern%20aesthetic%20with%20plenty%20of%20negative%20space%20editorial%20design%20style&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="Yoybuy Sheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col justify-center pt-24 md:pt-32 pb-0 px-6 md:px-10">
        <div className="w-full flex flex-col lg:flex-row lg:items-start gap-8 md:gap-12">
          <div className="lg:w-[60%]">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-[0.95] tracking-tight">
              <span className="block">{t("hero_title_line1")}</span>
              <span className="block text-2xl md:text-4xl lg:text-5xl mt-1">{t("hero_title_line2")}</span>
              <span className="block text-xl md:text-3xl lg:text-3xl mt-1 text-white/80">{t("hero_title_line3")}</span>
            </h1>
          </div>

          <div className="lg:w-[40%] lg:pt-3">
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-5 max-w-md">
              {t("hero_subtitle")}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 border-2 border-white/50 text-white rounded-2xl text-sm font-semibold hover:bg-white/10 hover:border-white transition-all cursor-pointer whitespace-nowrap group"
            >
              {t("hero_cta")}
              <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="relative z-10 mt-auto w-full h-[200px] md:h-[280px]">
        <div className="w-full h-full grid grid-cols-4 md:grid-cols-7 auto-rows-fr gap-0">
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Trendy%20white%20sneakers%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-shoes&orientation=squarish" alt="Shoes" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Stylish%20grey%20hoodie%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-hoodie&orientation=squarish" alt="Hoodie" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Basic%20white%20t-shirt%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-tshirt&orientation=squarish" alt="T-Shirt" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Modern%20lightweight%20jacket%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-jacket&orientation=squarish" alt="Jacket" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Trendy%20beige%20trousers%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-pants&orientation=squarish" alt="Pants" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-cap&orientation=squarish" alt="Cap" className="w-full h-full object-cover object-top" />
          </div>
          <div className="overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20product%20photography%20on%20pure%20white%20background%20clean%20minimalist%20ecommerce%20shot%20with%20soft%20studio%20lighting&width=280&height=280&seq=hero-mosaic-bag&orientation=squarish" alt="Bag" className="w-full h-full object-cover object-top" />
          </div>
        </div>
      </div>
    </section>
  );
}